window.Shopify = window.Shopify || {};

// Module-level guards
let __crossSellAdding = false; // prevents rapid double-submits across any button in the modal

/**
 * Formats money with fallback
 */
function formatCrossSellMoney(cents) {
  if (typeof Shopify.formatMoney === 'function') {
    const format = window.money_format || (window.Shopify && Shopify.money_format) || "{{ shop.money_format }}";
    try {
      return Shopify.formatMoney(cents, format);
    } catch (e) {
      console.warn('Shopify.formatMoney failed', e);
    }
  }
  return (cents / 100).toLocaleString() + ' K';
}

/**
 * Extracts product handle from cart data or URL
 */
function getProductHandleFromCartData(cartData) {
  if (cartData && cartData.handle) return cartData.handle;
  
  if (cartData && cartData.url) {
    const cleanUrl = cartData.url.split('?')[0];
    const match = cleanUrl.match(/\/products\/([^/?#]+)/);
    if (match && match[1]) return match[1];
  }

  if (window.location.pathname.includes('/products/')) {
    const match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (match && match[1]) return match[1];
  }

  return null;
}

/**
 * Opens the cross-sell modal using the native dialog element
 * @param {Object} cartData - Data from the cart add event
 */
function openCrossSellModal(cartData) {
  const modal = document.getElementById('CrossSellModal');
  const cartElement = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  const handle = getProductHandleFromCartData(cartData);

  if (!modal || !handle) {
    if (cartElement && cartData) cartElement.renderContents(cartData);
    return;
  }

  const addedProductContainer = modal.querySelector('#CrossSell-AddedProduct');
  const recommendationsContainer = modal.querySelector('#CrossSell-Recommendations');

  // 1. Update added product info
  if (addedProductContainer && cartData) {
    const img = addedProductContainer.querySelector('.added-product-image');
    const name = addedProductContainer.querySelector('.product-name');
    const price = addedProductContainer.querySelector('.product-price');

    const imageUrl = (typeof cartData.image === 'string' && cartData.image) 
      ? cartData.image 
      : (cartData.featured_image?.url || cartData.featured_image || '');

    if (img) {
      img.src = imageUrl;
      img.alt = cartData.product_title || cartData.title || '';
    }
    if (name) {
      name.textContent = cartData.product_title || cartData.title || '';
    }
    if (price && cartData.price != null) {
      price.textContent = formatCrossSellMoney(cartData.price);
    }
    addedProductContainer.hidden = false;
  }

  // 2. Fetch cross-sell products using Section Rendering API
  const rootUrl = (window.routes && window.routes.root_url) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cleanRoot = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';
  const productUrl = `${cleanRoot}products/${handle}?sections=cross-sell-products`;

  fetch(productUrl)
    .then(response => {
      if (!response.ok) throw new Error('Network response not ok: ' + response.status);
      return response.json();
    })
    .then(sections => {
      const html = sections['cross-sell-products'];
      if (!html) {
        if (cartElement && cartData) cartElement.renderContents(cartData);
        return;
      }

      // Use DOMParser to safely parse returned HTML string
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const content = doc.querySelector('.cross-sell-products');
      const items = content ? content.querySelectorAll('.cross-sell__item') : [];

      if (items.length > 0) {
        recommendationsContainer.replaceChildren(content);
        modal.showModal();
        document.body.classList.add('cross-sell-modal-open');

        initModalVariantSelectors(modal);
        initModalAddToCartButtons(modal);
      } else {
        // Fallback to normal cart drawer/notification if product has no cross-sells
        if (cartElement && cartData) cartElement.renderContents(cartData);
      }
    })
    .catch(error => {
      console.error('Error fetching cross-sells:', error);
      if (cartElement && cartData) cartElement.renderContents(cartData);
    });

  // Handle backdrop click to close
  modal.onclick = (e) => {
    if (e.target === modal) {
      closeCrossSellModal(null, false);
    }
  };
}

/**
 * Wires add-to-cart buttons inside the modal
 */
function initModalAddToCartButtons(modal) {
  modal.querySelectorAll('.modal-add-to-cart').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const itemContainer = btn.closest('.cross-sell__item');
      const variantInput = itemContainer ? itemContainer.querySelector('.variant-id-input') : null;
      const variantSelect = itemContainer ? itemContainer.querySelector('.variant-select') : null;
      const variantId = (variantSelect ? variantSelect.value : null) || btn.dataset.variantId || (variantInput ? variantInput.value : null);

      if (!variantId) {
        console.error('No variant ID found for cross-sell product');
        return;
      }

      if (__crossSellAdding) return;
      __crossSellAdding = true;

      btn.disabled = true;
      const btnText = btn.querySelector('.button-text');
      const spinner = btn.querySelector('.loading__spinner');
      if (btnText) btnText.classList.add('hidden');
      if (spinner) spinner.classList.remove('hidden');

      const rootUrl = (window.routes && window.routes.root_url) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const cleanRoot = rootUrl.endsWith('/') ? rootUrl : rootUrl + '/';
      const addUrl = cleanRoot + 'cart/add.js';

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      fetch(addUrl, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      })
        .then(response => {
          if (!response.ok) {
            console.error('Cross-sell add failed with status:', response.status);
            btn.disabled = false;
            if (btnText) btnText.classList.remove('hidden');
            if (spinner) spinner.classList.add('hidden');
            __crossSellAdding = false;
            return null;
          }
          return response.json();
        })
        .then(response => {
          if (response) {
            window.__pendingCartResponse = response;
            closeCrossSellModal(btn, true);
          }
        })
        .catch(err => {
          console.error('Cross-sell add network error:', err);
          btn.disabled = false;
          if (btnText) btnText.classList.remove('hidden');
          if (spinner) spinner.classList.add('hidden');
          __crossSellAdding = false;
        });
    });
  });
}

/**
 * Initialize variant selectors in the modal
 */
function initModalVariantSelectors(modal) {
  modal.querySelectorAll('.variant-select').forEach(select => {
    select.addEventListener('change', function() {
      const productItem = this.closest('.cross-sell__item');
      if (!productItem) return;

      const priceDisplay = productItem.querySelector('.price');
      const addButton = productItem.querySelector('.modal-add-to-cart');
      const variantInput = productItem.querySelector('.variant-id-input');
      const selectedOption = this.options[this.selectedIndex];

      if (addButton) addButton.dataset.variantId = this.value;
      if (variantInput) variantInput.value = this.value;
      if (priceDisplay && selectedOption && selectedOption.dataset.price) {
        priceDisplay.textContent = selectedOption.dataset.price;
      }
    });
  });
}

/**
 * Closes the cross-sell modal
 * @param {HTMLElement|null} clickedBtn - The button that triggered the close
 * @param {boolean} redirect - Whether to redirect to cart page
 */
function closeCrossSellModal(clickedBtn = null, redirect = false) {
  const modal = document.getElementById('CrossSellModal');
  if (!modal) return;

  const btn = clickedBtn || modal.querySelector('.cross-sell__button');
  if (btn) {
    const btnText = btn.querySelector('.button-text');
    if (btnText) btnText.textContent = 'Added to Cart';
    btn.querySelector('.loading__spinner')?.classList.add('hidden');
    btn.disabled = true;
  }

  if (redirect) {
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    window.location.href = cartUrl;
  } else {
    modal.close();
    document.body.classList.remove('cross-sell-modal-open');
    __crossSellAdding = false;
  }
}

/**
 * Helper to ensure Shopify.formatMoney is available
 */
if (typeof Shopify.formatMoney !== 'function') {
  Shopify.formatMoney = function(cents, format) {
    if (typeof cents === 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || "K {{amount}}";

    function defaultOption(opt, defaultValue) {
      return (typeof opt === 'undefined' ? defaultValue : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) { return 0; }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    if (!formatString.match(placeholderRegex)) return (cents/100).toFixed(2);

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}

/**
 * SIMULATE CROSS-SELL POPUP (FOR TESTING)
 * Run in Browser Console: testCrossSellModal('your-product-handle')
 */
window.testCrossSellModal = function(handle) {
  const dummyCartData = {
    handle: handle || "air-optix-aqua-hydraglyde",
    product_title: "Test Product",
    image: "",
    price: 1200000
  };

  openCrossSellModal(dummyCartData);
};